import { EndpointItemProps } from '~/types/migration'

export function EndpointItem({ endpoint, isSelected, onToggle }: EndpointItemProps) {
  const handleToggle = () => {
    onToggle(endpoint, !isSelected)
  }

  return (
    <div
      className='flex items-center cursor-pointer'
      onClick={handleToggle}
      style={{
        display: 'flex',
        height: '32px',
        padding: '0px',
        alignItems: 'center',
        alignSelf: 'stretch',
        borderRadius: '8px'
      }}
    >
      <div className='flex items-center gap-3 w-full px-2'>
        <div className='w-4 h-4 flex items-center justify-center flex-shrink-0'>
          {isSelected && (
            <svg className='w-4 h-4' viewBox='0 0 16 16' fill='#65558F'>
              <path d='M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z' />
            </svg>
          )}
        </div>
        <span
          className='flex-1'
          style={{
            overflow: 'hidden',
            color: isSelected ? '#65558F' : 'rgba(0, 0, 0, 0.88)',
            textOverflow: 'ellipsis',
            fontFamily: 'Geist',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: '22px'
          }}
        >
          {endpoint.name}
        </span>
      </div>
    </div>
  )
}
